

export const SalaryOrder = ["Ikke-uddannede", "Basismedarbejder", "Specialister", "Befalingsmænd", "Ledere"];


export const SalaryDelelementerPerformedOrder = ["Basisfortjeneste", "Pension", "Personalegoder", "Uregel. betalinger",  "Genetillæg", "Fraværsbetaling", "Overtidstillæg",];


export const SalaryDelelementerStandardOrder = ["Basisfortjeneste", "Pension", "Personalegoder", "Uregel. betalinger", "Genetillæg"];